import React, { useEffect, useState } from 'react'
import API from '../../services/api'
import TableLoader from '../../shared/TableLoader'
import NoDataFound from '../../shared/NoDataFound'
import { SlDrawer } from '@shoelace-style/shoelace/dist/react'
import {formatDateWithTime} from '../../utils/dateFormat'

function OrderLogs(props) {
    const {show, setShow, order_id} = props
    const [loader, setLoader] = useState(false)
    const [logData, setLogData] = useState()


    const fetchLogs = async()=>{
        setLoader(true)
        try {
            let res = await API({
                url:'/order/fetch-logs',
                method:'POST',
                responseType:'json',
                data:{
                    order_id
                }
            })
            if(res.code === 200){
                setLogData(res.data)
            }
        setLoader(false)
        } catch (error) {
            console.error(error)
        }
    }
    function handleRequestClose(event) {
        if (event.detail.source === "overlay") {
          event.preventDefault();
        }
      }

      

    useEffect(()=>{
        fetchLogs()
    },[order_id])
  return (
    <>
    <SlDrawer  label="Order Logs"
        open={show}
        onSlRequestClose={handleRequestClose}
        onSlAfterHide={() => {
          setShow(false);
        }}
        // style={{ "--size": "50vw" }}
        >
    <h6 className='text-center mb-2'>Logs</h6>
    <table className=" table table-bordered">
            <thead className="sticky top-0 ">
              <tr>
               <th>S.No</th>
               <th>Update</th>
               <th>UpdateBy</th>
               <th>Time</th>
              </tr>
            </thead>
            {logData?.length && !loader ? (
              <tbody>
                {logData.map((item, index) => {
                  return (
                   <tr>
                    <td>{index+1}</td>
                    <td>{item.update}</td>
                    <td>{item.update_by}</td>
                    <td>{formatDateWithTime(Math.round(item.time/1000)) || "-"} </td>
                   </tr>
                  );
                })}
              </tbody>
            ) : !logData?.length && !loader ? (
              <NoDataFound colspan="16" />
            ) : (
              <TableLoader colspan="16" />
            )}
          </table>
    </SlDrawer>
    
    </>
  )
}

export default OrderLogs